import { createContext, useContext, useEffect, useState } from "react";
import { useSocketContext } from "./socketContext";
// import { Alert } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert'
import "../assets/css/common.css";
import sendPlainMessage from "utils/sendPlainMessage";
import sendFileMessage from "utils/sendFileMessage";
import markAsUnread from "utils/markAsunread";
import Cookies from 'js-cookie';
import updateBot from "utils/updateBot";

const UsersContext = createContext();

const useUsersContext = () => useContext(UsersContext);

const UsersProvider = ({ children }) => {
	const socket = useSocketContext();
	const [users, setUsers] = useState('');
	const [alertMessage, setAlertMessage] = useState('');



	const _getAllData = (data) => {
		console.log('All Data is', data)
		setUsers(data) 
	};


	const _updateUserProp = (userId, prop, value) => {
		setUsers((users) => {
			const usersCopy = [...users];
			let userIndex = users.findIndex((user) => user._id === userId);
			console.log('USER CONTECTX _updateUserProp users', users)
			const userObject = usersCopy[userIndex];
			usersCopy[userIndex] = { ...userObject, [prop]: value };
			return usersCopy;
		});
	};

	const setUserAsTyping = (data) => {
		const { userId } = data;
		_updateUserProp(userId, "typing", true);
	};

	const setUserAsNotTyping = (data) => {
		const { userId } = data;
		_updateUserProp(userId, "typing", false);
	};

	const fetchMessageResponse = (data) => {
		setUsers((users) => {
			const { userId, response } = data;

			let userIndex = users.findIndex((user) => user._id === userId);
			const usersCopy = JSON.parse(JSON.stringify(users));
			const newMsgObject = {
				content: response,
				sender: userId,
				time: new Date().toLocaleTimeString(),
				status: null,
			};

			usersCopy[userIndex].messages.TODAY.push(newMsgObject);

			return usersCopy;
		});
	};
	
	// useEffect(() =>  {
	// 	const fetchData = async () => {
	// 		if(await getToken())
	// 			socket.emit('pullData', 'get data')
	// 	  }
		
	// 	  // call the function
	// 	  fetchData()
	// 		// make sure to catch any error
	// 		.catch(console.error);
	// }, []);

	useEffect(() => {
		socket.on('chatData', _getAllData)
		// socket.on("fetch_response", fetchMessageResponse);
		// socket.on("start_typing", setUserAsTyping);
		// socket.on("stop_typing", setUserAsNotTyping);
	}, [socket]);

	// socket.on("chatData", (data) => {
	// 	console.log("new message arrived", data);
	// 	setUsers(data);
	// });

	socket.on('chatData', _getAllData)

	const getToken = async () => {
		const token = Cookies.get('_auth');
		console.log('getToken', token);
		return token;
	}

	const setUserAsUnread = async (contactId) => {
		await markAsUnread(
			await getToken(),
			contactId,
		)

		socket.on('chatData', _getAllData)
	};

	const setBotStatus = async (contactId, status) => {
		await updateBot(
			await getToken(),
			contactId,
			status
		)

		socket.emit('pullData', 'get data')
	};


	const addNewMessage = async (userId, message) => {
		let userIndex = users.findIndex((user) => user._id === userId);
		let token = Cookies.get('_auth')
		console.log('Found token', token)
		if(token){
			try{
				await sendPlainMessage(
					Cookies.get('_auth'),
					users[userIndex]._id,
					message )
			}catch(err){
				console.log('error sending message', err.message)
				setAlertMessage({ variant: 'danger', message: err.message});
			}
		}
		else{
			setAlertMessage({ variant: 'danger', message: 'Token expired'});
		}

		
		socket.emit('pullData', 'get data')
		return true
	};

	const addNewFileMessage = async (userId, file) => {
		console.log("USERID in addNewFileMessage", userId)
		let userIndex = users.findIndex((user) => user._id === userId);
		console.log("userIndex in addNewFileMessage", userIndex)

		try{
			let response = await sendFileMessage(
				Cookies.get('_auth'),
				users[userIndex]._id,
				file
			)
			console.log('addNewFileMessage response', response)
			// setAlertMessage({ variant: 'success', message: "file sent"});

		}catch(err){
			console.log('error was recived in addNewFileMessage', err)
			setAlertMessage({ variant: 'danger', message: err.message});
		}
	
	
		// else
		socket.emit('pullData', 'get data')
	

	};

	  return (
		<div>
		{alertMessage && (
			<>
				<Alert variant={alertMessage.variant}>{alertMessage.message}</Alert>
				<div>
				<button className="close-button" type="button" onClick={() => setAlertMessage(false)}>X</button>
				</div>
			</>
		)}
		{
			<UsersContext.Provider value={{ users, setUserAsUnread, addNewMessage , addNewFileMessage, setBotStatus}}>
				{children}
			</UsersContext.Provider>
		}
	  </div>
	  );
};



export { useUsersContext, UsersProvider };